import {Component, Inject, OnInit} from '@angular/core';
import {plano} from "../../../models/plano";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Localiser} from "../../../services/localiser";
import {ZonaService} from "../../../services/zona.service";
import {DeviceService} from "../../../services/device.service";
import {Navigation} from "../../../services/navigation.service";
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'app-info-zone',
  templateUrl: './info-zone.component.html',
  styleUrls: ['./info-zone.component.css']
})
export class InfoZoneComponent implements OnInit {

  planos: Array<plano>;
  zona;

  constructor(public dialogRef: MatDialogRef<InfoZoneComponent>, @Inject(MAT_DIALOG_DATA) public data,
              public localiser: Localiser, public zonaService: ZonaService, public deviceService: DeviceService,
              public navigation: Navigation, public user: UserService) { }

  ngOnInit(): void {
    this.planos = this.data.planos;
    this.zona = this.data.zona;
  }

  getPlanoNombre(idPlano) {
    return this.planos.find(plano => plano.idPlano == idPlano).nombre;
  }

  getNumberOfRowsForLuminarias(luminarias) {
    return Array(Math.ceil(luminarias.length / 2));
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  seeOnMap() {
    this.deviceService.setSelectedZona(this.zona);
    this.navigation.toDevices();
    this.onCancelClick();
  }
}
